
<form
	[formGroup]="formG1"
	class="userForm"
>

	<div class="userPanel">

		<div class="categPanel">
			
			<mat-form-field appearance="outline">
				<mat-label>{{myInputs.ebeId.label}}</mat-label>
				<input 
					matInput
					[type]="myInputs.ebeId.type" 
					[formControlName]="myInputs.ebeId.id" 
					[placeholder]="myInputs.ebeId.placeholder || ''" 
					[required]="!!myInputs.ebeId.required"
					class="{{myInputs.ebeId.id}}_trivinput_{{myInputs.ebeId.type}}"
					[value]="myInputs.ebeId.defaultValue"
					[title]="myInputs.ebeId.title || ''"
				>
				<mat-hint>{{myInputs.ebeId.hint}}</mat-hint>
				<mat-error *ngIf="formG1.get('ebeId')?.invalid">{{myInputs.ebeId.errorMsg}}</mat-error>
			</mat-form-field>

			<div class="userGrid">

				<triv-input [fGroup]="formG1" [data]="myInputs.ebeAnrede" />
				<triv-input [fGroup]="formG1" [data]="myInputs.ebeTitel" />

				<triv-input [fGroup]="formG1" [data]="myInputs.ebeVorname" />
				<triv-input [fGroup]="formG1" [data]="myInputs.ebeName" />

				<triv-input [fGroup]="formG1" [data]="myInputs.ebePosition" />
				<triv-input [fGroup]="formG1" [data]="myInputs.ebeTelefon" />

				<mat-form-field
					style="width: 100%;"
					appearance="outline"
					[class.fieldError]="formG1.touched && !emailCtrl.disabled && !emailCtrl.valid"
				>

					<mat-label>{{myInputs.ebeMail.label}}</mat-label>
					<input
						matInput 
						type="email" 
						[formControlName]="myInputs.ebeMail.id" 
						[placeholder]="myInputs.ebeMail.placeholder || ''" 
						[spellcheck]="myInputs.ebeMail.spellcheck" 
						[required]="!!myInputs.ebeMail.required"
						class="{{myInputs.ebeMail.id}}_trivinput_{{myInputs.ebeMail.type}}"
						[value]="myInputs.ebeMail.defaultValue"
						[title]="myInputs.ebeMail.title || ''"
						autocomplete="do-not-autofill"
					>

					@if( formG1.touched && emailCtrl.errors ) {
						<mat-error>
							@if( emailCtrl.hasError( "required" ) ) {
								E-Mail-Adresse ist erforderlich
							}
							@else if( emailCtrl.hasError( "email" ) ) {
								Bitte eine gueltige E-Mail-Adresse eingeben
							}
							@else if( emailCtrl.hasError( "alreadyUsed" ) ) {
								Diese E-Mail-Adresse wurde schon benutzt
							}
							@else if( emailCtrl.hasError( "emailInvalid" ) ) {
								Diese E-Mail wird als ungültig betrachtet
							}
							@else {
								{{myInputs.ebeMail.errorMsg}}
							}
						</mat-error>
					}

				</mat-form-field>

				<mat-form-field
					appearance="outline"
					[class.fieldError]="formG1.touched && formG1.get('mitgliedId')?.invalid"
				>
					<mat-label>{{myInputs.mitgliedId.label}}</mat-label>

					<mat-select
						[formControlName]="myInputs.mitgliedId.id"
						[placeholder]="myInputs.mitgliedId.placeholder || ''" 
						[multiple]="myInputs.mitgliedId.multiple"
						[required]="!!myInputs.mitgliedId.required"
						class="{{myInputs.mitgliedId.id}}_trivinput_select"
					>
						@for( option of myInputs.mitgliedId.options; track option.id ) {
							<mat-option [value]="option">
								{{option.label}}
							</mat-option>
						}
					</mat-select>

					<mat-hint>{{myInputs.mitgliedId.hint}}</mat-hint>

					@if( formG1.touched && !formG1.get('mitgliedId')?.valid ) {
						<mat-error>{{myInputs.mitgliedId.errorMsg}}</mat-error>
					}

				</mat-form-field>

				<triv-input [fGroup]="formG1" [data]="myInputs.ansStrasse" />
				<triv-input [fGroup]="formG1" [data]="myInputs.ansHausnummer" />
				<triv-input [fGroup]="formG1" [data]="myInputs.ansPlz" />
				<triv-input [fGroup]="formG1" [data]="myInputs.ansOrt" />

			</div>

			<div class="userFlags">

				<triv-input [fGroup]="formG1" [data]="myInputs.ebeAktiv" />

				@if( environment.features.datenpflege ) {
					<triv-input [fGroup]="formG1" [data]="myInputs.bMaintenanceRights" />
				}

				<triv-input [fGroup]="formG1" [data]="myInputs.bAdminMember" />

				@if( environment.features.export ) {
					<triv-input [fGroup]="formG1" [data]="myInputs.bExportRights" />
				}

				<mat-checkbox [formControl]="mainContactCtrl">
					Hauptansprechpartner
				</mat-checkbox>

			</div>

			@if( bSaveError ) {
				<div class="errorWarning" style="text-align: center;">
					Beim Speichern des Benutzers ist ein Fehler aufgetreten
				</div>
			}

		</div>
			
		<div class="categPanel">
			<div class="aSubTitle">
				Veranstaltungsgruppen
			</div>
			<calendar-group-selector [userId]="user.ebeId" />
		</div>

		<div class="categPanel">
			<div class="aSubTitle">
				News Rubriken
			</div>
			<rubric-selector [userId]="user.ebeId" />
		</div>

		@if( environment.features.austausch ) {

			@if( user.gruppen && !user.gruppen.includes(UserRoles.ADMIN) ) {

				<div class="categPanel">
					<div class="aSubTitle">
						Austauschkategorien
					</div>
					<documentexchange-category-selector
						[userId]="user.ebeId"
						[memberId]="user.mitgliedId"
					/>
				</div>

			}

		}

		<div class="categPanel userButtons">

			<button
				mat-raised-button
				[disabled]="bInProgress"
				(click)="openPasswordDialog()"
			>
				<span class="material-icons textTop">key</span>
				Passwort bearbeiten
			</button>

			<button
				mat-raised-button color="warn"
				(click)="deleteUserDialog()"
				[disabled]="bInProgress"
			>
				<span class="material-icons textTop">delete</span>
				Löschen
			</button>

			<button
				mat-raised-button
				(click)="resetLoginAttempts()"
				[disabled]="bInProgress"
			>
				Anmeldeversuche zurücksetzen
			</button>

		</div>

		<div class="categPanel">
			<div class="aSubTitle">Zwei-Faktor-Authentifizierung</div>
			<app-manage-2fa [user]="_user"></app-manage-2fa>
		</div>

	</div>


</form>
